// extracted by mini-css-extract-plugin
var _1 = "joGN2UwoadUC6mxTMCfM";
var _2 = "xQZ2ngVOo57wTSA36AfJ";
var _3 = "lK7Q3EQhSRJ9PZmfpeSw";
var _4 = "nuV4PL4vcukm8xtwuFkd";
var _5 = "n1onfVpfnQbmdx2KKfG_";
export { _1 as "buttons", _2 as "duplicateModal", _3 as "modalTitle", _4 as "nameInput", _5 as "nameInputContainer" }
